'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import { userSessionAtom } from '@/store/atoms';
import { getIdentity, getUserSession } from '@/utility/loginHelpers';
import { tracker } from '@/utility/tracking/tracker';
import { hashMessage } from '@/utility/tracking/transformToTrackingOrder';
export const FetchUser = () => {
  const $ = _c(7);
  const [userSession, setUserSession] = useAtom(userSessionAtom);
  const [sessionFetched, setSessionFetched] = useState(false);
  let t0;
  let t1;
  if ($[0] !== setUserSession) {
    t0 = () => {
      const getSession = async () => {
        setUserSession(await getUserSession());
        setSessionFetched(true);
      };
      getSession();
    };
    t1 = [setUserSession];
    $[0] = setUserSession;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[3] !== sessionFetched || $[4] !== userSession) {
    t2 = () => {
      if (!sessionFetched) {
        return;
      }
      const trackVisitor = async () => {
        if (!userSession) {
          tracker.trackVisitor({
            userId: undefined,
            isLoggedIn: false,
            email: undefined,
            hashedEmail: undefined
          });
          return;
        }
        const identity = await getIdentity();
        tracker.trackVisitor({
          userId: userSession.id,
          isLoggedIn: true,
          email: identity?.email,
          hashedEmail: identity?.email ? await hashMessage(identity.email) : undefined
        });
      };
      trackVisitor();
    };
    t3 = [userSession, sessionFetched];
    $[3] = sessionFetched;
    $[4] = userSession;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  return null;
};